<template>
    <div class="align-center" v-if="isCurrentUserAdmin">
        <button @click="openTab" class="button is-info">
            <span class="icon is-small">
                <i class="fas fa-edit"></i>
            </span>
        </button>
    </div>

    <div class="modal" :class="[showTab ? 'is-active' : '']">
        <div class="modal-background"></div>
        <div class="modal-card">
            <header class="modal-card-head">
                <p class="modal-card-title">Update FD Details</p>
                <button @click="closeTab" class="delete" aria-label="close"></button>
            </header>
            <section class="modal-card-body">
                <div v-if="!!error" ref="errorNotification" class="notification is-danger mb-4">
                    <p>{{ error }}</p>
                </div>
                <table class="table">
                    <thead>
                        <tr>
                            <th style="width: 50%;">Spots For</th>
                            <th>Total</th>
                            <th>Open</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Redhill <i class="fas fa-car"></i></td>
                            <td>
                                <input v-model="currentFD.volunteers_drivers_required" class="input" type="number">
                            </td>
                            <td>
                                <input v-model="currentFD.volunteers_drivers_remaining" class="input" type="number">
                            </td>
                        </tr>
                        <tr>
                            <td>Redhill <i class="fas fa-person-walking"></i></td>
                            <td>
                                <input v-model="currentFD.volunteers_others_required" class="input" type="number">
                            </td>
                            <td>
                                <input v-model="currentFD.volunteers_others_remaining" class="input" type="number">
                            </td>
                        </tr>
                        <tr>
                            <td>TBR <i class="fas fa-person-walking"></i></td>
                            <td>
                                <input v-model="currentFD.tbr_volunteers_required" class="input" type="number">
                            </td>
                            <td>
                                <input v-model="currentFD.tbr_volunteers_remaining" class="input" type="number">
                            </td>
                        </tr>
                        <tr class="green">
                            <td>Sponsor Redhill <i class="fas fa-car"></i></td>
                            <td>
                                <input v-model="currentFD.sponsor_volunteers_drivers_required" class="input" type="number">
                            </td>
                            <td>
                                <input v-model="currentFD.sponsor_volunteers_drivers_remaining" class="input" type="number">
                            </td>
                        </tr>
                        <tr class="green">
                            <td>Sponsor Redhill <i class="fas fa-person-walking"></i></td>
                            <td>
                                <input v-model="currentFD.sponsor_volunteers_others_required" class="input" type="number">
                            </td>
                            <td>
                                <input v-model="currentFD.sponsor_volunteers_others_remaining" class="input" type="number">
                            </td>
                        </tr>
                        <tr class="green">
                            <td>Sponsor TBR <i class="fas fa-person-walking"></i></td>
                            <td>
                                <input v-model="currentFD.sponsor_tbr_volunteers_required" class="input" type="number">
                            </td>
                            <td>
                                <input v-model="currentFD.sponsor_tbr_volunteers_remaining" class="input" type="number">
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div class="field">
                    <label class="label">Sponsor's Name</label>
                    <div class="control">
                        <input v-model="currentFD.sponsor" class="input" type="text" placeholder="Sponsor's Name">
                    </div>
                </div>
                <div class="field">
                    <label class="label">Start time for volunteers</label>
                    <div class="control">
                        <input v-model="currentFD.time" class="input" type="time">
                    </div>
                </div>
            </section>
            <footer class="modal-card-foot">
                <button @click="saveChanges" class="button is-success" :class="[isLoading ? 'is-loading' : '']">Save
                    changes</button>
            </footer>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            showTab: false,
            error: null,
            isLoading: false
        }
    },
    computed: {
        isCurrentUserAdmin() {
            return this.$store.getters['user/isCurrentUserAdmin'];
        },
        currentFD() {
            return this.$store.getters['fd/getCurrentFD'];
        }
    },
    methods: {
        closeTab() {
            this.showTab = false;
        },
        openTab() {
            this.showTab = true;
        },
        async saveChanges() {
            this.isLoading = true;
            this.error = null;

            try {
                await this.$store.dispatch('fd/updateFDDetails', {
                    fdID: this.currentFD.id,
                    requiredDriving: this.currentFD.volunteers_drivers_required ?? 0,
                    remainingDriving: this.currentFD.volunteers_drivers_remaining ?? 0,
                    requiredOthers: this.currentFD.volunteers_others_required ?? 0,
                    remainingOthers: this.currentFD.volunteers_others_remaining ?? 0,
                    tbrRequired: this.currentFD.tbr_volunteers_required ?? 0,
                    tbrRemaining: this.currentFD.tbr_volunteers_remaining ?? 0,
                    sponsorRequiredDriving: this.currentFD.sponsor_volunteers_drivers_required ?? 0,
                    sponsorRemainingDriving: this.currentFD.sponsor_volunteers_drivers_remaining ?? 0,
                    sponsorRequiredOthers: this.currentFD.sponsor_volunteers_others_required ?? 0,
                    sponsorRemainingOthers: this.currentFD.sponsor_volunteers_others_remaining ?? 0,
                    sponsorTbrRequired: this.currentFD.sponsor_tbr_volunteers_required ?? 0,
                    sponsorTbrRemaining: this.currentFD.sponsor_tbr_volunteers_remaining ?? 0,
                    sponsor: this.currentFD.sponsor,
                    time: this.currentFD.time
                });
                this.isSuccess = true;
                this.showTab = false;
            } catch (error) {
                this.error = error.message || 'Something went wrong!';
                this.$nextTick(() => {
                    this.$refs.errorNotification?.scrollIntoView({ behavior: 'smooth', block: 'start' });
                });
            }
            this.isLoading = false;
        }
    }
}
</script>
